import { Fab, Paper } from "@mui/material";
import React from "react";
import Footer from "../Shared/Footer";
import { KeyboardArrowUp } from "@mui/icons-material";
import MultiVendorHeader from "../Shared/MultiVendorHeader";
import classNames from "classnames";
import AaraClouds from "../Pages/AaraClouds";

const Layout = ({ theme, setTheme, component, path }) => {
  const handleTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  console.log(path);
  return (
    <>
      <MultiVendorHeader />
      <Paper
        className={classNames(
          "w-full h-full pt-10 !rounded-none !bg-white",
          path === "/" ? "lg:!pt-0" : "lg:pt-[135px]"
        )}
      >
        {component}
      </Paper>
      <Fab
        color="inherit"
        onClick={handleTop}
        className="!fixed !p-2 !z-50 bottom-10 right-10"
      >
        <KeyboardArrowUp fontSize="large" />
      </Fab>
      <Footer />
    </>
  );
};

export default Layout;
